import { invalidateDemoTagAction } from '@/api/api'
import { useUpdateUserInfoMutation } from '@/api/user-api'
import { useDispatch } from '@/hooks/use-dispatch'

type UseUpdateLanguageReturnValue = (value: string) => Promise<void>

export const useUpdateLanguage = (): UseUpdateLanguageReturnValue => {
  const dispatch = useDispatch()
  const [updateUserInfo] = useUpdateUserInfoMutation()

  return async (value: string): Promise<void> => {
    await updateUserInfo({ language: value }).unwrap()
    dispatch(invalidateDemoTagAction)
  }
}
